import type { MicrositeRichContentEmbed } from '@cdf/microsite-layout';

const YOUTUBE_VIDEO_ID = /^[A-Za-z0-9_-]{6,20}$/;
const VIMEO_VIDEO_ID = /^\d{5,12}$/;

export function normalizeMicrositeEmbedUrl(provider: MicrositeRichContentEmbed['provider'], value: string): string | null {
  try {
    const url = new URL(value);
    if (url.protocol !== 'https:' || url.username || url.password) return null;
    if (provider === 'youtube') {
      const host = url.hostname.toLowerCase();
      const videoId = host === 'youtu.be'
        ? url.pathname.split('/').filter(Boolean)[0]
        : ['youtube.com', 'www.youtube.com', 'm.youtube.com'].includes(host)
          ? url.pathname === '/watch' ? url.searchParams.get('v') : url.pathname.startsWith('/embed/') ? url.pathname.split('/')[2] : null
          : host === 'www.youtube-nocookie.com' && url.pathname.startsWith('/embed/') ? url.pathname.split('/')[2] : null;
      return videoId && YOUTUBE_VIDEO_ID.test(videoId) ? `https://www.youtube-nocookie.com/embed/${videoId}` : null;
    }
    if (provider === 'vimeo') {
      const segments = url.pathname.split('/').filter(Boolean);
      const videoId = url.hostname === 'player.vimeo.com' && segments[0] === 'video'
        ? segments[1]
        : ['vimeo.com', 'www.vimeo.com'].includes(url.hostname) ? segments[0] : undefined;
      return videoId && VIMEO_VIDEO_ID.test(videoId) ? `https://player.vimeo.com/video/${videoId}` : null;
    }
    if (!['google.com', 'www.google.com', 'maps.google.com'].includes(url.hostname.toLowerCase())) return null;
    url.hash = '';
    if (url.pathname === '/maps/embed' && (url.searchParams.has('pb') || url.searchParams.has('q'))) return `https://www.google.com${url.pathname}${url.search}`;
    if (url.pathname === '/maps' && url.searchParams.get('output') === 'embed' && url.searchParams.has('q')) return `https://www.google.com${url.pathname}${url.search}`;
  } catch {
    return null;
  }
  return null;
}
